import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * Rename, re-tag or refresh one saved item.
 *
 * An unknown id and another user's id both answer 404 ITEM_NOT_FOUND — the same
 * answer on purpose, so this cannot be used to discover whether an id exists.
 *
 * @param {string} itemId
 * @param {{name?: string, tags?: string[], payload?: Object}} changes
 * @returns {Promise<{item: Object}>}
 */
async function saved_items_update(itemId, changes = {}) {
  return generic_backend_request_post({ item_id: itemId, ...changes }, '/saved_items_update');
}

export default saved_items_update;
